<template>
    <div id="input-profile-page">
        <div v-if="isMobile">
            {{ trans('pages.input_profile_page.mobile_warning') }}
        </div>
        <div v-else>
            <div class="field">
                <label for="profilefile">
                    {{ trans('pages.input_profile_page.file_select_label') }}
                </label>
                <br />
                <input
                    type="file"
                    id="profilefile"
                    name="profilefile"
                    @change="onChange"
                />
            </div>
            <div>
                <table>
                    <thead>
                        <tr>
                            <td>
                                {{
                                    trans('pages.input_profile_page.line_count')
                                }}
                            </td>
                            <td>
                                {{
                                    trans(
                                        'pages.input_profile_page.correctly_processed'
                                    )
                                }}
                            </td>
                            <td>
                                {{ trans('pages.input_profile_page.error') }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td id="csvCount">{{ csvCount }}</td>
                            <td id="csvCorrect">{{ csvCorrect }}</td>
                            <td id="csvError">{{ csvError }}</td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <spinner-text v-if="processing">
                    {{ trans('pages.input_profile_page.processing') }}
                </spinner-text>
            </div>
            <div>
                <template v-for="(msg, index) in csvErrorMsgs">
                    <span :key="'errorMsg.' + index">
                        {{ msg }}
                        <br />
                    </span>
                </template>
            </div>
            <hr />
        </div>
    </div>
</template>
<script>
import SpinnerText from '../components/loader/SpinnerText';
import profileApi from '../api/profile';
import * as Papa from 'papaparse';
import { isMobile } from '../helpers/GeneralHelper';
import { showInfoMessage, showErrorMessage } from '../dialogs';
import localization from '../mixins/localization';

export default {
    components: { SpinnerText },
    mixins: [localization],
    data() {
        return {
            columns: null,
            processing: false,
            csvCount: 0,
            csvCorrect: 0,
            csvError: 0,
            csvErrorMsgs: [],
        };
    },
    computed: {
        isMobile: () => isMobile(),
    },
    mounted() {
        profileApi.exportColumns().then((response) => {
            this.columns = response.data.data;
        });
    },
    methods: {
        onChange(evt) {
            this.csvCount = 0;
            this.csvCorrect = 0;
            this.csvError = 0;
            this.csvErrorMsgs = [];
            const files = evt.target.files;
            if (files[0]) {
                const reader = new FileReader();

                const self = this;
                reader.onload = ((theFile) => {
                    return function (e) {
                        self.parseCsv(e.target.result);
                    };
                })(files[0]);

                reader.readAsText(files[0]);
            }
        },
        parseCsv(fileText) {
            this.processing = true;

            Papa.parse(fileText, {
                complete: (results) => {
                    this.csvCount = results.data.length;
                    showInfoMessage(
                        this.trans('pages.input_profile_page.analysis', {
                            count: this.csvCount,
                        })
                    );

                    const difference = this.columns
                        .filter((x) => !results.meta.fields.includes(x))
                        .concat(
                            results.meta.fields.filter(
                                (x) => !this.columns.includes(x)
                            )
                        );

                    if (difference.length > 0) {
                        this.processing = false;

                        return showErrorMessage(
                            this.trans(
                                'pages.input_profile_page.column_differences',
                                { columns: difference.join(', ') }
                            )
                        );
                    }

                    if (results.errors.length > 0) {
                        showErrorMessage(
                            this.trans('pages.input_profile_page.format_errors')
                        );
                        this.processing = false;
                        return results.errors.forEach((error) => {
                            this.csvError++;
                            this.csvErrorMsgs.push(
                                this.trans(
                                    'pages.input_profile_page.line_error',
                                    { line: error.row, message: error.message }
                                )
                            );
                        });
                    }

                    const rawLines = fileText
                        .split(/\r\n|\r|\n/)
                        .filter((x) => x.length > 0);

                    this.saveCsvToServer(rawLines);
                },
                header: true,
                delimiter: '', // Auto-detect delimiter (PapaParse built-in)
                skipEmptyLines: true,
                dynamicTyping: false,
            });
        },
        saveCsvToServer(resultArray) {
            profileApi
                .import(resultArray)
                .then((response) => {
                    this.$store.commit(
                        'general/addRunningTask',
                        response.data.data,
                        { root: true }
                    );
                    showInfoMessage(
                        this.trans(
                            'pages.input_profile_page.background_processing'
                        )
                    );
                    window.setTimeout(() => {
                        this.$router.push('/');
                    }, 2000);
                })
                .catch(() => {
                    this.csvError++;
                    this.csvErrorMsgs.push(
                        this.trans('pages.input_profile_page.db_error')
                    );
                    showErrorMessage(
                        this.trans('pages.input_profile_page.db_add_error')
                    );
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
